import { render, staticRenderFns } from "./CustomFormMobile.vue?vue&type=template&id=52215d3e&scoped=true&"
import script from "./CustomFormMobile.vue?vue&type=script&lang=js&"
export * from "./CustomFormMobile.vue?vue&type=script&lang=js&"
import style0 from "./CustomFormMobile.vue?vue&type=style&index=0&id=52215d3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52215d3e",
  null
  
)

export default component.exports